<iconify-icon [height]="lineHeight()" [icon]="icon()" [rotate]="rotate()" />
